// ============================================================
// src/config/api.js
// Single source of truth for all API URLs.
// ============================================================

export const XAMPP_BASE = "https://brandpartners.in";

// All API calls go through this one endpoint
export const API_BASE = `${XAMPP_BASE}/api/portfolio.php`;

// ── Build full image URL ─────────────────────────────────────
// Handles 3 cases:
// 1. Already full URL  → "http://localhost/uploads/x.jpg"  → return as-is
// 2. Relative path     → "/uploads/x.jpg"                 → prepend XAMPP_BASE
// 3. Empty / null      → return null
export const getImageUrl = (imagePath) => {
  if (!imagePath || imagePath.trim() === "") return null;
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath; // already full URL — don't double-prefix
  }
  return `${XAMPP_BASE}${imagePath.startsWith("/") ? imagePath : "/" + imagePath}`;
};

// ── Build full video URL ─────────────────────────────────────
export const getVideoUrl = (videoPath) => {
  if (!videoPath || videoPath.trim() === "") return null;
  if (videoPath.startsWith("http://") || videoPath.startsWith("https://")) {
    return videoPath;
  }
  return `${XAMPP_BASE}${videoPath.startsWith("/") ? videoPath : "/" + videoPath}`;
};